<template>
  <v-card class="dashboard__card" elevation="0">
    <v-card-title>
      <div class="dashboard__card--icon mt-1" :class="resource.class">
        <v-img
          :src="resource.icon"
          class="dashboard__card--subtotals--icon"
          max-width="28px"
          height="20"
          contain
        />
      </div>
      <p class="font-weight-bold mb-0 ml-2">
        {{ resource.name || summary.name }}
      </p>
    </v-card-title>
    <v-card-text>
      <div
        class="dashboard__card--total"
        :class="{ clickable: resource.linkTo }"
        @click="() => handleClick()"
      >
        <h1>{{ getFormattedValue(summary.total) }}</h1>
      </div>
      <v-img
        v-if="!isMobile"
        src="@/assets/svg/dashboard-arrow-right.svg"
        class="dashboard__card--subtotals--icon"
        max-width="28px"
        height="20"
        contain
      />
      <div class="subtotals-container">
        <div
          class="dashboard__card__subtotals"
          v-for="(subtotal, index) in filteredSubTotals"
          :key="index"
        >
          <div
            :class="{ clickable: resource.linkTo }"
            @click="() => handleClick(subtotal.name)"
            class="text-wrapper"
          >
            <div class="dashboard__card__subtotals__value">
              {{ getFormattedValue(subtotal.value) }}
            </div>
            <div class="dashboard__card__subtotals__label">
              {{ subtotal.name | startCase }}
            </div>
          </div>
          <v-img
            v-if="isLastItem(index) && !isMobile"
            src="@/assets/svg/dashboard-arrow-right.svg"
            class="dashboard__card--subtotals--icon"
            max-width="28px"
            height="20"
            contain
          />
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { getNumberAsMonetaryValue } from "@/utils/helpers";
import { size, filter } from "lodash";
import { isPermissioned } from "@/utils/permissions";

export default {
  props: {
    /**
     *  Summary Object
     */
    summary: {
      type: Object,
      required: false
    },
    organisationId: String
  },
  computed: {
    resource() {
      switch (this.summary.name) {
        case "Bookings":
          return {
            icon: require("@/assets/svg/booking_icon_clickable.svg"),
            linkTo: "bookings",
            name: "Roles"
          };
        case "Applications":
          return {
            icon: require("@/assets/svg/application_icon.svg")
          };
        case "Offers":
          return {
            icon: require("@/assets/svg/offer_blue_icon.svg")
          };
        default:
          return {
            icon: require("@/assets/svg/booking_icon_clickable.svg")
          };
      }
    },
    filteredSubTotals() {
      let filterMethod = null;
      switch (this.summary.name) {
        case "Bookings":
          filterMethod = name => isPermissioned(`dashboard.bookings-${name}`);
          break;
        case "Applications":
          filterMethod = name =>
            isPermissioned(`dashboard.applications-details.${name}`) ||
            name === "draft";
          break;
      }
      if (filterMethod) {
        return filter(this.summary.subTotals, ({ name }) => filterMethod(name));
      }
      return this.summary.subTotals;
    }
  },
  methods: {
    handleClick(status) {
      if (this.resource.linkTo) {
        this.$router.push({
          name: this.resource.linkTo,
          params: {
            ...(status && { status }),
            organisationId: this.organisationId
          }
        });
      }
    },
    getFormattedValue(value) {
      return this.resource.isAmount
        ? getNumberAsMonetaryValue(value, "GBP")
        : value;
    },
    isLastItem(index) {
      return index + 1 !== size(this.summary.subTotals);
    }
  }
};
</script>

<style lang="scss"></style>
